<template>
  <div>
    <el-table
      :data="simplifyShopsHireLogInfo.owners"
      style="margin-top: 10px"
      border
      :cell-style="{ whiteSpace: 'nowrap' }"
    >
      <!-- 乙方名称（匹配接口的partyBName） -->
      <el-table-column
        prop="partyBName"
        label="乙方名称"
        align="center"
        min-width="120"
      ></el-table-column>

      <!-- 合同名称：接口无直接字段，用houseAddress+templateCode拼接 -->
      <el-table-column label="合同名称" align="center" min-width="180">
        <template slot-scope="scope">
          {{ getContractName(scope.row) }}
        </template>
      </el-table-column>

      <!-- 负责人：匹配接口的contractManager（显示ID，若有姓名接口可补充映射） -->
      <!-- <el-table-column label="负责人" align="center" min-width="120">
        <template slot-scope="scope">
          {{ scope.row.contractManager || "无" }}
        </template>
      </el-table-column> -->

      <!-- 签订日期（匹配接口的signDate） -->
      <el-table-column
        prop="signDate"
        label="签订日期"
        align="center"
        min-width="140"
      ></el-table-column>

      <!-- 创建时间（匹配接口的createTime） -->
      <el-table-column
        prop="createTime"
        label="创建时间"
        align="center"
        min-width="160"
      ></el-table-column>

      <!-- 操作列：跳转至newContractManage -->
      <el-table-column label="操作" align="center" min-width="100">
        <template slot-scope="scope">
          <el-button size="mini" @click="_openContractDetail(scope.row)">
            查看合同
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-size="pageSize"
      layout="total, prev, pager, next"
      :total="total"
      class="pagination"
    ></el-pagination>
  </div>
</template>

<script>
import { queryContractNew } from "@/api/contract/newContractManageApi";
import { getCommunityId } from "@/api/community/communityApi";

export default {
  name: "SimplifyShopsHireLog",
  data() {
    return {
      simplifyShopsHireLogInfo: {
        owners: [], // 存储合同列表（数组）
        ownerId: "",
        roomId: "", // 存储当前房屋ID
      },
      currentPage: 1,
      pageSize: 10,
      total: 0,
      communityId: "",
    };
  },
  created() {
    this.communityId = getCommunityId();
  },
  methods: {
    open(params) {
      this.handleSwitch(params);
    },

    handleSwitch(params) {
      if (!params.roomId) return;
      this.clearSimplifyShopsHireLogInfo();
      this.simplifyShopsHireLogInfo.roomId = params.roomId; // 单独赋值房屋ID
      this.listShopsHireLog();
    },

    // 加载当前房屋的合同列表（修复参数+数据赋值）
    async listShopsHireLog() {
      try {
        const params = {
          page: this.currentPage - 1,
          row: this.pageSize,
          communityId: this.communityId,
          selectedHouse: this.simplifyShopsHireLogInfo.roomId, // 参数名改为roomId
        };
        const res = await queryContractNew(params);
        this.simplifyShopsHireLogInfo.owners = res.data || []; // 赋值给数组
        this.total = res.total || 0;
      } catch (error) {
        console.error("加载房屋合同列表失败:", error);
        this.$message.error("加载失败");
      }
    },

    // 查看合同：跳转至newContractManage
    _openContractDetail(row) {
      this.$router.push({
        path: "/pages/admin/newContractManage",
        query: { id: row.contractId },
      });
    },

    // 清空数据
    clearSimplifyShopsHireLogInfo() {
      this.simplifyShopsHireLogInfo = {
        owners: [],
        ownerId: "",
        roomId: "",
      };
      this.currentPage = 1;
      this.total = 0;
    },

    // 分页切换
    handleCurrentChange(val) {
      this.currentPage = val;
      this.listShopsHireLog();
    },

    // 拼接合同名称（houseAddress + 模板类型）
    getContractName(row) {
      const templateMap = {
        houseRent: "房屋租赁合同",
        houseRentNew: "光谷房屋租赁协议",
      };
      const templateName = templateMap[row.templateCode] || "未知合同";
      return `${templateName}`;
    },
  },
};
</script>

<style scoped>
.pagination {
  margin-top: 15px;
  text-align: right;
}
/* 修复列宽溢出 */
.el-table {
  width: 100%;
  overflow-x: auto;
}
</style>
